import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { CryptoService } from '../services/crypto.service';
import { storageUtil } from 'src/app/utils';
import { BrowserService } from '../services/browser.service';
import {
  ADMIN_USERS,
  API_CONSTANTS,
  COLLEGE_RECON_CONSTANTS,
} from 'src/app/constants';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  constructor(
    private _cryptoService: CryptoService,
    private _storageUtil: storageUtil,
    private _browserService: BrowserService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const encryptedData =
      this._browserService.checkBrowser() &&
      this._storageUtil.getItem('loggedInUser');
    const user = JSON.parse(
      this._cryptoService.decryptData(
        encryptedData,
        COLLEGE_RECON_CONSTANTS.userEncryptDecryptSecretKey,
      ),
    );
    if (
      ADMIN_USERS.includes(user.type) &&
      state.url.includes(API_CONSTANTS.COLLEGE)
    ) {
      return true;
    }

    if (
      user.type === COLLEGE_RECON_CONSTANTS.userTypes.user &&
      state.url.includes(API_CONSTANTS.STUDENT)
    ) {
      return true;
    }
    history.back();
    return false;
  }
}

export const RoleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state,
) => {
  return inject(PermissionsService).canActivate(route, state);
};
